import React from 'react';
import './header.scss';
import './header-bvi.scss';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import SearchForm from './search-form';
import Bvi from '../../bvi/bvi';
import HeaderLogo from './header-logo';
import HeaderNavigation from './header-navigation';
import BurgerMenu from './burger-menu';
import ProfileMenu from './profile-menu';
import menuItemShape from './menu-item-shape';

// Base openedu header component
const Header = ({
  isMobile,
  isFixed,
  isTransparent,
  menuItems,
  isUserAuthenticated,
  authenticatedProfileMenuItems,
  myProfileLabel,
  searchPlaceholder,
  isBviVisible,
  auth,
  className,
}) => (
  <header className={classNames('header',
    {
      'header--fixed': isFixed,
      'header--transparent': isTransparent,
      'header--mobile': isMobile,
    },
    className)}
  >
    <div className="header__content">
      {isMobile && <BurgerMenu items={menuItems} />}
      <HeaderLogo className="header__logo" />
      {!isMobile && (
      <>
        <HeaderNavigation items={menuItems} />
        <SearchForm className="header__search-form" placeholder={searchPlaceholder} />
      </>
      )}
      {isUserAuthenticated
        ? (
          <ProfileMenu
            isMobile={isMobile}
            items={authenticatedProfileMenuItems}
            label={myProfileLabel}
          />
        )
        : (
          auth && (
          <div className="header__auth-btns">
            <a
              className="header__button"
              href={auth.loginHref === '#'
                ? auth.loginHref
                : `${auth.loginHref}?next=${encodeURIComponent(global.location.href)}`}
            >
              {auth.loginLabel}
            </a>
            {/*<a*/}
            {/*  className="header__button header__button--primary header__register-btn"*/}
            {/*  href={auth.registerHref}*/}
            {/*>*/}
            {/*  {auth.registerLabel}*/}
            {/*</a>*/}
          </div>
          )
        )}
      {isBviVisible && <Bvi className="header__bvi" />}
    </div>
  </header>
);

Header.propTypes = {
  isMobile: PropTypes.bool,
  isFixed: PropTypes.bool,
  isTransparent: PropTypes.bool,
  menuItems: PropTypes.arrayOf(menuItemShape),
  authenticatedProfileMenuItems: PropTypes.arrayOf(menuItemShape),
  isBviVisible: PropTypes.bool,
  isUserAuthenticated: PropTypes.bool,
  auth: PropTypes.shape({
    loginLabel: PropTypes.string,
    loginHref: PropTypes.string,
    registerLabel: PropTypes.string,
    registerHref: PropTypes.string,
  }),
  searchPlaceholder: PropTypes.string.isRequired,
  myProfileLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Header.defaultProps = {
  isMobile: false,
  isFixed: false,
  isTransparent: false,
  menuItems: [],
  authenticatedProfileMenuItems: [],
  isUserAuthenticated: true,
  isBviVisible: true,
  auth: undefined,
  className: undefined,
};

export default Header;
